import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useEffect, useState } from "react";
import apiClient from "Utils/apiClient";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ImageModal from "components/ImageModal";
import EmptyData from "components/EmptyData";
import DataTable from "examples/Tables/DataTable";
import { useSelector } from "react-redux";

function FeedbackData() {
  const getUserState = useSelector((state) => state?.data?.getUserState);
  const [rows, setRows] = useState([]);
  const [searchTxt, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");

  const columns = [
    { Header: "SR", accessor: "SR", align: "left" },
    { Header: "UserImage", accessor: "UserImage", align: "left" },
    { Header: "Name", accessor: "Name", align: "left" },
    { Header: "Email", accessor: "Email", align: "left" },
    { Header: "Feedback Type", accessor: "Feedback_Type", align: "left" },
    { Header: "Feedback", accessor: "Feedback", align: "left" },
    { Header: "State", accessor: "State", align: "left" },
    { Header: "Feedback Image", accessor: "Feedback_Image", align: "left" },
  ];

  const getData = async () => {
    setLoading(true);
    let index = 0;

    try {
      const userData = JSON.parse(localStorage.getItem("user")) || {};
      const { superAdmin, state: userState } = userData;
      const selectedState = getUserState || "All State";

      const response = await apiClient.get("/users/all-feedbacks?limit=1000");
      const users = response?.data || [];
      const feedbackRows = [];

      users.forEach((user) => {
        const rowState = user?.state || user?.userState;
        const userStateMatches = rowState === selectedState;
        const isUserVisible =
          (superAdmin && (selectedState === "All State" || userStateMatches)) ||
          (!superAdmin && rowState === userState);

        const feedbacks = Array.isArray(user.feedbackHistory) ? user.feedbackHistory : 
                          (user.feedback ? Object.values(user.feedback) : []);

        if (feedbacks.length > 0 && isUserVisible) {
          feedbacks.forEach((fb) => {
            index++;
            feedbackRows.push({
              SR: index,
              UserImage: (
                <img
                  src={user.userImage}
                  alt="user"
                  style={{ width: 50, height: 50, borderRadius: "50%", cursor: "pointer" }}
                  onClick={() => {
                    setIsModalOpen(true);
                    setOnClickImageData(user.userImage);
                  }}
                />
              ),
              Name: user.userName || "N/A",
              Email: fb.email,
              Feedback: fb.feedback || "N/A",
              Feedback_Type: fb.type,
              State: rowState,
              Feedback_Image: (
                <img
                  src={fb.imageUrl}
                  alt="feedback"
                  style={{ width: 50, height: 50, borderRadius: "50%", cursor: "pointer" }}
                  onClick={() => {
                    setIsModalOpen(true);
                    setOnClickImageData(fb.imageUrl);
                  }}
                />
              ),
            });
          });
        }
      });

      setRows(feedbackRows);
    } catch (error) {
      console.error("Failed to fetch feedback data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    getData();
  }, [getUserState]);

  useEffect(() => {
    if (searchTxt.trim() === "") {
      getData();
    } else {
      const filtered = rows.filter(
        (row) =>
          row.Name?.toLowerCase().includes(searchTxt.toLowerCase()) ||
          row.Feedback?.toLowerCase().includes(searchTxt.toLowerCase())
      );
      setRows(filtered);
    }
  }, [searchTxt]);

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar value={searchTxt} onChange={handleSearchChange} />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <ToastContainer />
                  <MDTypography variant="h6" color="white">
                    User Feedback
                  </MDTypography>
                </MDBox>

                <MDBox pt={3}>
                  {rows.length > 0 ? (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  ) : (
                    <EmptyData />
                  )}
                </MDBox>
              </Card>

              <ImageModal
                onClickImageData={onClickImageData}
                onClose={onClose}
                isModalOpen={isModalOpen}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default FeedbackData;
